import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, ExporterBodySchema } from "schema"
import { z } from "zod"

type Response = DataResponse<{ success: boolean }>

type Props = z.infer<typeof ExporterBodySchema>

export function useExportTableMutation() {
  return useMutation({
    mutationFn: async (props: Props) => {
      const response = await axios.post<Response>(`/exporter/`, props)

      return response.data.data
    },
  })
}
